import styled from 'styled-components/macro';
import { SelectHolderText } from './fontElements';

export const SelectHolderComponent = styled(SelectHolderText)`
  .Select {
    .Select-control {
      border-color: #e1e6f2 !important;
      background-color: #ffffff !important;
    }

    .Select-menu-outer {
      border-color: #e1e6f2 !important;
    }

    .Select-clear-zone {
      top: -2px;
      right: 0;

      .Select-clear {
        font-size: 14px;
      }
    }

    .Select-arrow-zone {
      bottom: 5px;
      right: 0;
      width: auto;
      height: 10px;
      padding-right: 6px;

      .Select-arrow {
        top: 0;
        border: 0;
        width: 7px;
        height: 10px;
        background-size: 7px !important;
        background: url('/images/new-designs/chevron-down.svg') no-repeat;
      }
    }

    &.is-open {
      .Select-arrow-zone {
        .Select-arrow {
          background: url('/images/new-designs/chevron-up.svg') no-repeat;
        }
      }
    }

    &:focus {
      outline: none;
    }

    .Select-multi-value-wrapper {
      background-color: #ffffff;

      &:after {
        background-color: #ffffff;
      }

      .Select-value {
        border-color: #a8aab7 !important;
        color: #000000;
        background-color: #ffffff;

        .Select-value-icon {
          border-color: transparent !important;
        }
      }

      .Select-value {
        height: 20px;
      }

      .Select-input {
        height: 25px;

        input {
          padding: 0px;
          height: 25px;
        }

        div {
          width: calc(100% - 20px);
        }
      }

      .Select-placeholder {
        background-color: #ffffff;
        line-height: 25px !important;
      }
    }
  }

  .MultiFilterEmpty {
    .Select-control {
      height: 25px !important;
    }

    .Select-arrow-zone {
      bottom: 8px;
    }
  }
`;

export const SearchSelectHolderComponent = styled(SelectHolderText)`
  .Select {
    .Select-control {
      border-color: #e1e6f2 !important;
      height: 25px !important;
    }

    .Select-menu-outer {
      border-color: #e1e6f2 !important;
    }

    .Select-clear-zone {
      top: 0;
      right: 25;

      .Select-clear {
        font-size: 14px;
      }
    }

    .Select-placeholder {
      background-color: white !important;
    }

    &:focus {
      outline: none;
    }

    .Select-multi-value-wrapper {
      background-color: #f8fafc;

      &:after {
        background-color: #ffffff;
      }

      .Select-value {
        border-color: #a8aab7 !important;
        color: #000000;
        background-color: #ffffff;

        .Select-value-icon {
          border-color: transparent !important;
        }
      }

      .Select-value {
        display: flex;
        align-items: center;
        height: 100%;
      }

      .Select-input {
        height: 25px;
      }

      .Select-placeholder {
        background-color: #f8fafc;
        height: 100%;
        display: flex;
        align-items: center;
      }
    }
  }

  .MultiFilterEmpty {
    .Select-control {
      height: 25px !important;
    }

    .Select-arrow-zone {
      bottom: 8px;
    }
  }
`;

export const SearchDropDownHolderComponent = styled(SelectHolderText)`
  width: 230px;
  margin-left: ${(props) => (props.label ? '3px' : '0px')};
  z-index: ${(props) => (props.zIndexOff ? 'auto' : '100')};

  .Select {
    .Select-control {
      height: 25px !important;
      border-color: #e1e6f2 !important;

      .Select-multi-value-wrapper {
        .Select-value,
        .Select-placeholder {
          line-height: 25px !important;
        }
      }
    }

    .Select-menu-outer {
      .Select-menu {
        .Select-option {
          line-height: 25px !important;
        }
      }
    }
  }
`;
